export const storeName = 'DeliveryModes';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    LOAD_DELIVERY_MODES: `${storeName}.LOAD_DELIVERY_MODES`,
    SET_DELIVERY_MODES: `${storeName}.SET_DELIVERY_MODES`,
    SET_DELIVERY_MODE: `${storeName}.SET_DELIVERY_MODE`,
    SET_DELIVERY_BLOCKED: `${storeName}.SET_DELIVERY_BLOCKED`,
    SET_DELIVERY_MODE_ON_PAYMENT_STEP: `${storeName}.SET_DELIVERY_MODE_ON_PAYMENT_STEP`,
    SET_CHECK_RTS: `${storeName}.SET_CHECK_RTS`,
    SET_RTS_AVAILABLE: `${storeName}.SET_RTS_AVAILABLE`,
    SET_RTS_UNREACHABLE_MSG: `${storeName}.SET_RTS_UNREACHABLE_MSG`,
    SET_SHOW_RTS_UNREACHABLE_MSG: `${storeName}.SET_SHOW_RTS_UNREACHABLE_MSG`,
    OPEN_DIALOG_GWP_DELIVERY_METHOD_CONFIRMATION: `${storeName}.OPEN_DIALOG_GWP_DELIVERY_METHOD_CONFIRMATION`,
};
